/** End a rich-text preview after a complete text row, including its paragraph spacing. */
export function measureDescriptionPreview(content: HTMLElement, maximumHeight: number): number {
  const box = content.getBoundingClientRect();
  if (box.height <= maximumHeight) return box.height;

  const lines: { top: number; bottom: number }[] = [];
  const walker = content.ownerDocument.createTreeWalker(content, NodeFilter.SHOW_TEXT);
  const range = content.ownerDocument.createRange();
  let node: Node | null;

  while ((node = walker.nextNode())) {
    if (!node.textContent?.trim()) continue;
    range.selectNodeContents(node);
    for (const rect of Array.from(range.getClientRects())) {
      if (rect.width <= 0 || rect.height <= 0) continue;
      const top = rect.top - box.top;
      const bottom = rect.bottom - box.top;
      if (bottom > maximumHeight) return completeHeight(top);
      const previous = lines[lines.length - 1];
      if (previous && Math.abs(top - previous.top) < 2) {
        previous.bottom = Math.max(previous.bottom, bottom);
      } else {
        if (lines.length === 4) return completeHeight(top);
        lines.push({ top, bottom });
      }
    }
  }
  return completeHeight();

  function completeHeight(nextTop = maximumHeight) {
    const last = lines[lines.length - 1];
    // Leave a small descender/underline allowance, without revealing the following row.
    return last
      ? Math.min(maximumHeight, last.bottom + Math.min(3, Math.max(0, nextTop - last.bottom) / 2))
      : maximumHeight;
  }
}
